var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 35,
    viewBox: "0 0 168 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.74 0H48.49V34.56H34.15L25.85 16.14H25.4V34.56H13.65V0H27.99L36.29 18.42H36.74V0ZM51.71 34.56V0H65.54V34.56H51.71ZM98.72 0V10.78H90.42V34.56H76.59V10.78H68.29V0H98.72ZM130.52 0V9.82H115.31V12.9H129.14V21.64H115.31V24.72H130.52V34.54H101.49V0H130.52Z",
    fill: "#D4DE25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32 34.56C1.94 34.56 0 32.62 0 30.24C0 27.86 1.94 25.92 4.32 25.92C6.7 25.92 8.64 27.86 8.64 30.24C8.64 32.62 6.71 34.56 4.32 34.56ZM4.32 26.41C2.21 26.41 0.48 28.14 0.48 30.25C0.48 32.36 2.21 34.09 4.32 34.09C6.43 34.09 8.16 32.36 8.16 30.25C8.16 28.14 6.43 26.41 4.32 26.41Z",
    fill: "#D4DE25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73 28.31H4.91C5.64 28.31 6.12 28.76 6.12 29.38C6.12 30 5.77 30.38 5.26 30.45C5.74 30.52 5.85 30.76 5.92 31.07L6.33 32.28H5.4L5.05 31.24C4.95 30.96 4.81 30.83 4.39 30.83H3.66V32.28H2.73V28.27V28.31ZM5.15 29.55C5.15 29.2 4.94 29 4.46 29H3.63V30.14H4.46C4.94 30.14 5.15 29.93 5.15 29.59V29.55Z",
    fill: "#D4DE25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.94 0L149.91 12.03H150.36L152.29 0H167.39L161.17 17.18V17.46L167.39 34.57H152.29L150.35 22.44H149.9L147.93 34.57H132.83L139.05 17.46V17.18L132.83 0H147.94Z",
    fill: "#D4DE25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b1941ff97b9ef8e224226e4b515cd366.svg";
export { ForwardRef as ReactComponent };